import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// API Base URL
const BASE_URL = "https://api.recdbase.org/message";

// Helper function to get token from localStorage
const getToken = () => localStorage.getItem("userToken");

// Get all conversations (left sidebar chat list)
export const fetchAllChats = createAsyncThunk(
  "chat/fetchAllChats",
  async (_, { rejectWithValue }) => {
    try {
      const token = getToken();
      if (!token) throw new Error("Unauthorized");

      const response = await axios.get(`${BASE_URL}/all`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(response.data);
      
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Get messages of a specific chat
export const fetchChatMessages = createAsyncThunk(
  "chat/fetchMessages",
  async (chatId, { rejectWithValue }) => {
    try {
      const token = getToken();
      if (!token) throw new Error("Unauthorized");

      const response = await axios.get(`${BASE_URL}/getMessages/${chatId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(response.data);
      
      return { chatId, messages: response.data };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Send a message
export const sendMessage = createAsyncThunk(
  "chat/sendMessage",
  async ({ receiverId, content }, { rejectWithValue }) => {
    try {
      const token = getToken();
      if (!token) throw new Error("Unauthorized");

      const response = await axios.post(
        `${BASE_URL}/sendMessage`,
        { receiverId, content },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response.data);
      
      return response.data; // This should include the sent message
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

const chatSlice = createSlice({
  name: "chat",
  initialState: {
    conversations: [],
    messages: {},
    loading: false,
    error: null,
  },
  reducers: {
    clearChatState: (state) => {
      state.conversations = [];
      state.messages = {};
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllChats.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllChats.fulfilled, (state, action) => {
        state.loading = false;
        state.conversations = action.payload;
      })
      .addCase(fetchAllChats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchChatMessages.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchChatMessages.fulfilled, (state, action) => {
        state.loading = false;
        const { chatId, messages } = action.payload;
        state.messages[chatId] = messages || []; // Store messages by chatId
      })
      .addCase(fetchChatMessages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(sendMessage.fulfilled, (state, action) => {
        const message = action.payload;
        if (!state.messages[message.chatId]) {
          state.messages[message.chatId] = [];
        }
        state.messages[message.chatId].push(message);
      })
      .addCase(sendMessage.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { clearChatState } = chatSlice.actions;
export default chatSlice.reducer;
